import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=0a074c15&scoped=true&"
import script from "./MessagesView.vue?vue&type=script&lang=js&"
export * from "./MessagesView.vue?vue&type=script&lang=js&"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=0a074c15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a074c15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a074c15')) {
      api.createRecord('0a074c15', component.options)
    } else {
      api.reload('0a074c15', component.options)
    }
    module.hot.accept("./MessagesView.vue?vue&type=template&id=0a074c15&scoped=true&", function () {
      api.rerender('0a074c15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/MessagesView.vue"
export default component.exports